import {
  types,
  IPublishedSearchPacksAction,
  IPublishedSearchPacksSuccessAction,
  IPublishedFailureAction,
  IUpdatePublishedSkipQuery,
  IResetPublishedSearchAction,
} from '../types/publishedSearch'
import { IPublishedGraphicBasic } from '../types/publishedGraphic'
import { IQuery } from '../types/search'

export const searchPublishedPacks = (
  query: IQuery
): IPublishedSearchPacksAction => ({
  type: types.PUBLISHED_SEARCH_PACKS__STARTED,
  query,
})

export const searchPublishedPacksSuccess = (
  items: IPublishedGraphicBasic[],
  totalCount: number
): IPublishedSearchPacksSuccessAction => ({
  type: types.PUBLISHED_SEARCH_PACKS__SUCCESS,
  items,
  totalCount,
})

export const searchPublishedPacksFailure = (
  message: string
): IPublishedFailureAction => ({
  type: types.PUBLISHED_SEARCH_PACKS__FAILURE,
  message,
})

export const updatePublishedSkipQuery = (
  skip: number
): IUpdatePublishedSkipQuery => ({
  type: types.UPDATE_PUBLISHED_SKIP_QUERY,
  skip,
})

export const resetPublishedSearch = (): IResetPublishedSearchAction => ({
  type: types.RESET_PUBLISHED_SEARCH,
})
